module.exports = __webpack_public_path__ + "static/media/Logo12.2d4ef442.png";